/* 카카오 지도 — 지도를 쓰는 페이지만 싣는다 ($page_js = array('map')). (2026-09-23, layout.js 의 지도 부분 + recommend-view.js 통합)
 *   .dmap #daum-map   승선위치·코스상세·추천여행 상세·예약 내역의 작은 지도 (주소 → 좌표 지오코딩, 저장 좌표가 있으면 그대로 · 누르면 큰 지도 모달)
 *   dmapModal()       예매조회 큰 지도 모달 (ajax_myorder.php w=dm 이 부른다)
 *   .map-apps [data-map-app] 지도 앱 단추(카카오맵·네이버지도·티맵 — 모든 길찾기, 2026-10-11) · .dmap-cover 작은 지도 덮개(휴대폰 스크롤)
 *   옛 #rvMap(추천여행 상세 지도 · window.rvMapConfig)은 2026-10-13 추천여행 상세 새 화면에서 작은 지도로 합쳤다(data-lat·lng·pin·name·h) */
// @ui:common @pv:cv — 이 파일의 화면 글은 파트너센터 다국어 설정 미리보기 「코스상세」 화면에(이용위치 작은 지도 — 채널 빌드 표지)

$(function () {
	if (typeof kakao === 'undefined' || !kakao.maps) return;
	if (kakao.maps.load) kakao.maps.load(smallMap);
	else smallMap();
});

// 주소 → 좌표(한 번 찾은 주소는 기억 — 길찾기 단추가 누르는 순간 바로 열리게: 기다렸다 열면 PC 는 새 창이 막힐 수 있다)
var MAP_PTS = {};
function geoPt(addr, cb) {
	if (MAP_PTS[addr]) { cb(MAP_PTS[addr]); return; }
	new kakao.maps.services.Geocoder().addressSearch(addr, function (result, status) {
		if (status !== kakao.maps.services.Status.OK || !result.length) return;
		MAP_PTS[addr] = { lat: +result[0].y, lng: +result[0].x, addr: addr };
		cb(MAP_PTS[addr]);
	});
}

//   #daum-map 의 data-addr(주소) · data-lat·data-lng(저장 좌표 — 있으면 주소를 찾지 않고, 지도 앱 단추·큰 지도도 이 좌표) · data-pin(핀 그림) · data-name(핀 위 이름 띠) · data-h(높이, 처음 250)
//   상세 창(app.js coursePanel)이 내용을 바꿀 때마다 다시 부른다 — 그 안의 지도 하나
function smallMap() {
	if (!$('.dmap').length) return;
	var $box = $('#daum-map');
	var addr = String($box.data('addr') || ''), lat = parseFloat($box.data('lat')), lng = parseFloat($box.data('lng')), pin = $box.data('pin'), name = String($box.data('name') || '');
	$box.css('height', (parseInt($box.data('h'), 10) || 250) + 'px');
	var el = document.getElementById('daum-map');
	// 덮개(2026-10-11 대표 지시) — 카카오 지도가 터치를 가져가 휴대폰에서 지도 위를 밀어도 페이지가 스크롤되지 않았다.
	//   작은 지도는 움직이지 않는 그림이라 투명 단추를 덮어 밀면 페이지 스크롤 · 누르면 큰 지도 창(옛 지도 클릭과 같음)
	var cover = document.createElement('button');
	cover.type = 'button';
	cover.className = 'dmap-cover';
	cover.setAttribute('aria-label', __('큰 지도로 보기'));   // __() = app.js(이 파일보다 뒤에 실리지만 지도는 페이지가 다 열린 뒤 그린다)
	cover.addEventListener('click', function () { $('#mo-map').modal('show'); });
	el.insertAdjacentElement('afterend', cover);
	function draw(p) {
		var coords = new kakao.maps.LatLng(p.lat, p.lng);
		var map = new kakao.maps.Map(el, { center: coords, level: 3, zoomable: false, scrollwheel: false, draggable: false, disableDoubleClick: true });
		var mk = { map: map, position: coords };
		if (pin) mk.image = new kakao.maps.MarkerImage(String(pin), new kakao.maps.Size(32, 32));
		new kakao.maps.Marker(mk);
		if (name) new kakao.maps.CustomOverlay({ map: map, position: coords, content: '<div class="dmap-label">' + name.replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }) + '</div>', yAnchor: 1, zIndex: 3 });
		map.setCenter(coords);
	}
	if (lat && lng) {
		var p = { lat: lat, lng: lng, addr: addr };
		if (addr) MAP_PTS[addr] = p;
		draw(p);
	} else if (addr) geoPt(addr, draw);
}

function dmapModal() {
	var $box = $('#mo-daum-map');
	var addr = $box.data('addr');
	$box.css('height', '100%');
	var el = document.getElementById('mo-daum-map');
	geoPt(String(addr || ''), function (p) {   // 작은 지도가 저장 좌표로 그렸으면 그 좌표(추천여행 상세 — 2026-10-13)
		var coords = new kakao.maps.LatLng(p.lat, p.lng);
		var map = new kakao.maps.Map(el, { center: coords, level: 10 });
		new kakao.maps.Marker({ map: map, position: coords });
		map.setCenter(coords);
		// 창이 올라오는 중(크기 0)에 만들어지면 그림 한 칸만 그려지고 가운데가 왼쪽 위로 갔다(2026-10-11 휴대폰 아래 시트) — 다 열리면 크기를 다시 재고 가운데로
		function fit() { map.relayout(); map.setCenter(coords); }
		$('#mo-map').one('shown.bs.modal', fit);
		setTimeout(fit, 400);
		$('.map-control').off('click').on('click', '.zoom-in', function () { map.setLevel(map.getLevel() - 1); }).on('click', '.zoom-out', function () { map.setLevel(map.getLevel() + 1); });   // 열 때마다 쌓이지 않게
	});
}

// ── 지도 앱 단추 [카카오맵][네이버지도][티맵] (2026-10-11 대표 지시 — 요즘핫플 상품 상세와 같은 모양·동작, 모든 길찾기 단추가 이것 하나)
//   PC        = 웹 지도 새 창(카카오맵 = 길찾기 도착지 · 네이버지도 = 주소 검색 — 요즘핫플과 같음), 티맵은 웹이 없어 안내
//   안드로이드 = intent:// — 앱이 있으면 앱의 길찾기, 없으면 크롬이 플레이 스토어로(시간 재기 없음)
//   아이폰    = 앱 주소로 열고, 2.5초 안에 페이지가 숨지 않으면(앱 없음) 앱스토어로
//   요즘핫플 옛 동작과 다른 점: 휴대폰에서 앱이 열려도 1.5초 뒤 스토어로 넘어갈 수 있던 것(시간만 쟀다)을 페이지가 숨었는지로 막음
var MAP_APPS = {
	kakao: { name: '카카오맵', pkg: 'net.daum.android.map', ios: 'https://apps.apple.com/kr/app/id304608425',
		app: function (p) { return 'kakaomap://route?ep=' + p.lat + ',' + p.lng + '&by=CAR'; },
		web: function (p, n) { return 'https://map.kakao.com/link/to/' + encodeURIComponent(n) + ',' + p.lat + ',' + p.lng; } },
	naver: { name: '네이버지도', pkg: 'com.nhn.android.nmap', ios: 'https://apps.apple.com/kr/app/id311867728',
		app: function (p, n) { return 'nmap://route/car?dlat=' + p.lat + '&dlng=' + p.lng + '&dname=' + encodeURIComponent(n) + '&appname=' + location.hostname; },
		web: function (p, n) { return 'https://map.naver.com/p/search/' + encodeURIComponent(p.addr || n); } },
	tmap: { name: '티맵', pkg: 'com.skt.tmap.ku', ios: 'https://apps.apple.com/kr/app/id431589174',
		app: function (p, n) { return 'tmap://route?goalname=' + encodeURIComponent(n) + '&goalx=' + p.lng + '&goaly=' + p.lat; },
		web: null },
};
function mapApp(type, p, name) {
	var a = MAP_APPS[type];
	if (!a || !p) return;
	var ua = navigator.userAgent;
	var android = /android/i.test(ua), ios = /iphone|ipad|ipod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);   // 아이패드는 PC 이름표를 단다
	if (!android && !ios) {
		if (a.web) window.open(a.web(p, name), '_blank', 'noopener');
		else if (window.Swal) Swal.fire({ title: __('{name}은 휴대폰 앱에서만 열 수 있습니다.', { name: __(a.name) }) });   // 앱 이름은 PHP map_apps_html() 의 __('티맵') 등과 같은 글
		else alert(__('{name}은 휴대폰 앱에서만 열 수 있습니다.', { name: __(a.name) }));
		return;
	}
	var url = a.app(p, name);
	if (android) {
		var i = url.indexOf('://');
		location.href = 'intent://' + url.slice(i + 3) + '#Intent;scheme=' + url.slice(0, i) + ';package=' + a.pkg + ';end';
		return;
	}
	var t = setTimeout(function () { if (!document.hidden) location.href = a.ios; }, 2500);
	function stop() { clearTimeout(t); document.removeEventListener('visibilitychange', stop); window.removeEventListener('pagehide', stop); }
	document.addEventListener('visibilitychange', stop);
	window.addEventListener('pagehide', stop);
	location.href = url;
}
// 단추 묶음 <div class="map-apps" data-addr="주소" data-name="도착지 이름"> 안 <button data-map-app="kakao|naver|tmap"> — 주소로 좌표를 찾아(기억) 연다
$(document).on('click', '[data-map-app]', function (e) {
	e.preventDefault();
	var box = $(this).closest('.map-apps'), type = $(this).data('map-app'), name = String(box.data('name') || '');
	if (typeof kakao === 'undefined' || !kakao.maps || !kakao.maps.services) return;
	geoPt(String(box.data('addr') || ''), function (p) { mapApp(type, p, name); });
});
